export const MOTORCYCLES = 'Motorcycles';
export const BIKES = 'Bikes';
export const ONE_CRORE = 10000000;
export const ONE_LAKH = 100000;
export const ONE_THOUSAND = 1000;
export const TWENTY_ITEMS = 20;
export const LOCATION_TYPE = 'CITY';
export const LOCATION_LIMIT = 30;
export const VEHICLES_CATEGORY_ID = '5';

export const categoryWiseFooterLinkText = {
    // Cars category 2011 Used Cars in Delhi
    84: {
        location: 'Used Cars in {city}',
        price: 'Used Cars Under {value} in {city}',
        first_owner: 'Used {value} Owner Cars in {city}',
        mileage: 'Used Cars Under {value} Kms in {city}',
        year: '{value} Used Cars in {city}',
        defaultText: 'Used {value} Cars in {city}'
    },
    // Bikes category
    2198: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        mileage: 'Used {category} Under {value} Kms in {city}',
        year: '{value} Used {category} in {city}',
        defaultText: 'Used {value} {category} in {city}'
    },
    // Property category
    3: {
        location: '{category} in {city}',
        price: '{category} Under {value} in {city}',
        year: '{value} {category} in {city}',
        type: '{value} in {city}',
        price_per_ft: '{value} Price Per Sq. Ft. Area in {city}',
        furnished: '{value} {category} in {city}',
        listed_by: '{value} in {city}',
        constructionstatus: '{value} in {city}',
        bachelors: '{value} Rentals in {city}',
        price_per_yd: '{value} Price Per Sq. Yd. Area in {city}',
        yd: 'Plot Area Between {value} in {city}',
        subtype: '{value} in {city}',
        defaultText: '{value} {category} in {city}'
    },
    // Mobile category
    1411: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        make: 'Used {value} {category} in {city}',
        type: 'Used {value} {category} in {city}',
        defaultText: 'Used {value} {category} in {city}'
    },
    1453: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        make: 'Used {value} {category} in {city}',
        type: 'Used {value} {category} in {city}',
        defaultText: 'Used {value} {category} in {city}'
    },
    // Jobs category
    4: {
        location: '{category} Jobs in {city}',
        job_type: '{value} {category} Jobs in {city}',
        work_mode: '{value} Jobs in {city}',
        salary_period: '{value} Salary Jobs in {city}',
        defaultText: '{value} in {city}'
    },
    // Electronics appliances category
    99: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        defaultText: 'Used {value} in {city}'
    },
    // Commercial vehicles spares category
    2207: {
        location: 'Used {category} in {city}',
        mileage: 'Used {category} Under {value} Kms in {city}',
        price: 'Used {category} Under {value} in {city}',
        year: 'Used {value} {category} in {city}',
        defaultText: 'Used {value} in {city}'
    },
    // Furniture category id: furniture_c628
    628: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        defaultText: 'Used {value} in {city}'
    },
    // Fashion category id: fashion_c87
    87: {
        location: 'Used {category} Clothes in {city}',
        price: 'Used {category} Clothes Under {value} in {city}',
        defaultText: 'Used {value} Clothes in {city}'
    },
    // Books sports hobbies category id: books-sports-hobbies_c767
    767: {
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}',
        defaultText: 'Used {value} in {city}'
    },
    // Pet category id: pets_c103
    103: {
        location: '{category} in {city}',
        price: '{category} Under {value} in {city}',
        defaultText: '{value} in {city}'
    },
    // Services category id: services_c619
    619: {
        location: '{category} in {city}',
        type: '{value} in {city}',
        defaultText: '{value} in {city}'
    },
    defaultText: 'Used {category} in {city}'
};

export const categoryWiseFooterLinkSeoText = {
    1587: {
        categoryName: 'Bikes & Scooters Spare Parts',
        location: 'Used {category} in {city}',
        price: 'Used {category} Under {value} in {city}'
    },
    1725: {
        categoryName: 'Houses & Apartments for Sale',
        location: '{category} in {city}',
        price: '{category} in {city} under {value}',
        type: '{value} for Sale in {city}',
        furnished: '{value} {category} in {city}',
        listed_by: '{category} by {value} in {city}',
        constructionstatus: '{value} Properties for Sale in {city}'
    },
    1723: {
        categoryName: 'Houses & Apartments for Rent',
        location: '{category} in {city}',
        price: '{category} in {city} under {value}',
        type: '{value} for Rent in {city}',
        furnished: '{value} {category} in {city}',
        listed_by: 'Properties For Rent by {value} in {city}',
        bachelors: 'Rooms for Rent in {city} for {value}'
    },
    1729: {
        location: 'Lands & Plots for Sale in {city}',
        type: 'Lands & Plots {value} in {city}',
        listed_by: 'Lands & Plots for Sale by {value} in {city}'
    },
    1731: {
        location: 'Shops & Offices for Rent in {city}',
        listed_by: 'Shops & Offices for Rent by {value} in {city}',
        furnished: '{value} Shops & Offices for Rent in {city}'
    },
    1733: {
        location: 'Shops & Offices for Sale in {city}',
        price: '{category} in {city} under {value} ',
        listed_by: 'Shops & Offices for Sale by {value} in {city}',
        furnished: '{value} Shops & Offices for Sale in {city}',
        constructionstatus: '{value} Shops & Offices for Sale in {city}'
    },
    1449: {
        listed_by: 'PG & Guest Houses by {value} in {city}'
    },
    85: {
        location: 'Used Commercial Vehicles in {city}',
        year: 'Used {value} Commercial Vehicles in {city}'
    },
    1585: {
        type: 'Used Commercial Vehicles {value} in {city}'
    },
    1523: {
        location: 'Second Hand TV in {city}',
        price: 'Second Hand TV Under {value} in {city}'
    },
    1417: {
        location: 'Used Kitchen Appliances in {city}'
    },
    771: {
        location: 'Used Gym & Fitness Equipments in {city}'
    }
};

const refurbishedCityHeading = 'Refurbished Mobiles in Popular Cities';
const refurbishedCityTemplate = 'Refurbished Mobiles in {location}';

const refurbishedByBrand = 'Refurbished Mobiles by Brand';
const refurbishedByBrandTemplate = 'Refurbished {make} Mobiles';

export const REFURBISHED_FILTER = 'state';
export const BRAND_FILTER = 'make';
export const TYPE_FILTER = 'type';

export const locationSpecificTitle = {
    4: {
        COUNTRY: {
            work_mode: '{value} Jobs in Popular States'
        },
        STATE: {
            work_mode: '{value} Jobs in Popular Cities'
        },
        CITY: {
            work_mode: '{value} Jobs in Nearby Cities',
            work_mode_other: '{value} Jobs in Other Cities'
        },
        NEIGHBOURHOOD: {
            work_mode: '{value} Jobs in Nearby Localities'
        }
    },
    1453: {
        [REFURBISHED_FILTER]: {
            COUNTRY: {
                heading: refurbishedCityHeading,
                template: refurbishedCityTemplate
            },
            STATE: {
                heading: refurbishedCityHeading,
                template: refurbishedCityTemplate
            },
            CITY: {
                heading: 'Refurbished Mobiles in Other Nearby Cities',
                template: refurbishedCityTemplate
            }
        },
        [BRAND_FILTER]: {
            COUNTRY: {
                heading: refurbishedByBrand,
                template: refurbishedByBrandTemplate
            },
            STATE: {
                heading: refurbishedByBrand,
                template: refurbishedByBrandTemplate
            },
            CITY: {
                heading: refurbishedByBrand,
                template: refurbishedByBrandTemplate
            }
        }
    },
    1449: {
        COUNTRY: {
            type: '{value} in Popular States'
        },
        STATE: {
            type: '{value} in Popular Cities'
        },
        CITY: {
            type: '{value} in Nearby Cities'
        },
        NEIGHBOURHOOD: {
            type: '{value} in Nearby Localities'
        }
    }
};

export const sellLocationSpecificTitle = {
    1411: {
        location: 'Sell Old {category} in {city}',
        defaultText: 'Sell Old {category} in {city}'
    },
    84: {
        location: 'Sell Used {category} in {city}',
        defaultText: 'Sell Used {category} in {city}'
    }
};
export const sellLocationSpecificTitleEntryPoint = {
    defaultText: 'Sell Old {category} in {city}'
};

export const sellCategorySpecificTitle = {
    1453: {
        brand: 'Sell Old {brandName} {category}'
    },
    84: {
        brand: 'Sell Used {brandName}'
    }
};

export const categorySpecificFooterTitle = {
    1453: 'Sell Old Mobile Phones',
    84: 'Sell Old Cars'
};
